import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Stack, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EuroOutlinedIcon from '@mui/icons-material/EuroOutlined';
import { useTranslation } from 'react-i18next';

import TuoteHintarivit from '@/components/Hintarivit/TuoteHintarivit';

const KoriHintarivit = ({ laskutustiedot, tuotteet }) => {
  const { t } = useTranslation();

  return (
    <Accordion
      sx={{
        'boxShadow': 'none',
        'marginTop': 0,
        '&:before': {
          display: 'none',
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="address-content"
        id="address-header"
        sx={{
          'padding': 0,
          'minHeight': 0,
          'borderBottom': 'none',
          '&.Mui-expanded': {
            minHeight: 0,
            borderBottom: 'none',
          },
          '& .MuiAccordionSummary-content': {
            margin: 0,
          },
        }}
      >
        <Stack direction="row" alignItems="center" spacing={2} sx={{ width: '100%' }}>
          <EuroOutlinedIcon />
          <Typography sx={{ flex: 1 }}>
            {t('koriHintarivit.totalPrice')}
          </Typography>
          <Typography>
            {(laskutustiedot.korinSumma != null) ? `${laskutustiedot.korinSumma} €` : t('koriHintarivit.noBilling')}
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: 0 }}>
        {
          tuotteet.tuotteet !== null && tuotteet.tuotteet.map(tuote => (<TuoteHintarivit key={tuote.id.tuoteId} tuote={tuote} />))
        }
      </AccordionDetails>
    </Accordion>
  );
};

export default KoriHintarivit;
